import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const UpdateContentSlice = createSlice({
    name: "updateContentRequest",
    initialState,
    reducers: {
        updateContentRequest(state) {
            state.loading = true;
        },
        updateContentRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        updateContentRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        updateContentStateReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    updateContentRequest,
    updateContentRequestSuccess,
    updateContentRequestError,
    updateContentStateReset,
} = UpdateContentSlice.actions;

export default UpdateContentSlice.reducer;
